module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "core"
    }
  }, [_c('header', [_c('div', {
    staticClass: "cover"
  }, [_c('h1', [_vm._v("核心企业")]), _vm._v(" "), _c('section', [_c('span', {
    class: _vm.active === 'N+1' ? 'active' : '',
    on: {
      "click": function($event) {
        _vm.active = 'N+1'
      }
    }
  }, [_vm._v("N+1解决方案")]), _vm._v(" "), _c('span', {
    class: _vm.active === '1+N' ? 'active' : '',
    on: {
      "click": function($event) {
        _vm.active = '1+N'
      }
    }
  }, [_vm._v("1+N解决方案")])]), _vm._v(" "), (_vm.active === 'N+1') ? _c('footer', [_c('div', {
    staticClass: "contant"
  }, [_c('h2', [_vm._v("如何延长付款账期")]), _vm._v(" "), _c('h3', [_vm._v("群星金融可提供一款“N+1现金采购”的供应链金融解决方案，基于核心企业对应付账款的确认/付款承诺，资金方受让供应商对核心企业的应收账款，给供应商提供融资/现金结算；核心企业可以延长对供应商的付款账期，获得经营性现金流；也可以获取融资利差。")]), _vm._v(" "), _c('h5', {
    on: {
      "click": function($event) {
        return _vm.topage('download', 'download-core')
      }
    }
  }, [_vm._v("下载方案")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/imgs/portal/case/n+1@2x.png",
      "alt": "img"
    }
  })]) : (_vm.active === '1+N') ? _c('footer', [_c('div', {
    staticClass: "contant"
  }, [_c('h2', [_vm._v("如何提前收取经销商货款")]), _vm._v(" "), _c('h3', [_vm._v("群星通过对核心企业的应收账款进行资产分析，并引入金融机构购买应收账款资产，核心企业可以在风险不变、现金流不变的前提下，拉长给经销商的赊销账期，从而解决经销商的资金压力，帮助核心企业扩大销售规模。")]), _vm._v(" "), _c('h5', {
    on: {
      "click": function($event) {
        return _vm.topage('download', 'download-core')
      }
    }
  }, [_vm._v("下载方案")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/imgs/portal/case/1+n@2x.png",
      "alt": "img"
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "advantage"
  }, [_c('div', {
    staticClass: "cover"
  }, [_c('h1', [_vm._v("对比银行贷款或发行债券，群星金融方案的优势在于")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h2', [_vm._v("同时，群星会提供基于方案的如下供应链金融服务")]), _vm._v(" "), _c('h3', {
    on: {
      "click": function($event) {
        return _vm.topage('service')
      }
    }
  }, [_vm._v("进一步了解")]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "cover"
  }, [_c('h1', [_vm._v("这里有适合您的资金方案")]), _vm._v(" "), _c('h2', [_vm._v("留下您的联系方式，我们的顾问将随时为您提供帮助")]), _vm._v(" "), _c('portal-form', {
    attrs: {
      "from": "case-core",
      "roleType": _vm.active
    }
  }), _vm._v(" "), _vm._m(3)], 1)]), _vm._v(" "), _c('portal-footer', {
    attrs: {
      "page": "download-core",
      "roleType": _vm.active
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', [_c('strong', [_vm._v("01")]), _vm._v(" "), _c('span', [_vm._v("获得经营性现金流"), _c('br'), _vm._v("不增加公司有息负债")])]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("02")]), _vm._v(" "), _c('span', [_vm._v("不占贷款和发债额度"), _c('br'), _vm._v("为公司留更多借款空间")])]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("03")]), _vm._v(" "), _c('span', [_vm._v("优化财务报表"), _c('br'), _vm._v("提升供应链整体竞争力")])]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("04")]), _vm._v(" "), _c('span', [_vm._v("融资稳定性更高"), _c('br'), _vm._v("较不宜受市场波动的影响")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('div', [_c('img', {
    staticClass: "img-1",
    attrs: {
      "src": "/imgs/portal/home/zijin_1@2x.png",
      "alt": "img"
    }
  }), _vm._v(" "), _c('span', [_vm._v("资金方案")])]), _vm._v(" "), _c('div', [_c('img', {
    staticClass: "img-2",
    attrs: {
      "src": "/imgs/portal/home/data_1@2x.png",
      "alt": "img"
    }
  }), _vm._v(" "), _c('span', [_vm._v("数据分析")])]), _vm._v(" "), _c('div', [_c('img', {
    staticClass: "img-3",
    attrs: {
      "src": "/imgs/portal/home/lianshu_1@2x.png",
      "alt": "img"
    }
  }), _vm._v(" "), _c('span', [_vm._v("链属营销")])]), _vm._v(" "), _c('div', [_c('img', {
    staticClass: "img-4",
    attrs: {
      "src": "/imgs/portal/home/line_1@2x.png",
      "alt": "img"
    }
  }), _vm._v(" "), _c('span', [_vm._v("线上平台")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bank"
  }, [_c('div', {
    staticClass: "cover"
  }, [_c('div', {
    staticClass: "cover-line"
  }, [_c('img', {
    attrs: {
      "src": "/imgs/portal/case/bank1@2x.png",
      "alt": "img"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/imgs/portal/case/bank2@2x.png",
      "alt": "img"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/imgs/portal/case/bank3@2x.png",
      "alt": "img"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/imgs/portal/case/bank4@2x.png",
      "alt": "img"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "cover-line",
    attrs: {
      "id": "anchor"
    }
  }, [_c('img', {
    attrs: {
      "src": "/imgs/portal/case/bank5@2x.png",
      "alt": "img"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/imgs/portal/case/bank6@2x.png",
      "alt": "img"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/imgs/portal/case/bank7@2x.png",
      "alt": "img"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/imgs/portal/case/bank8@2x.png",
      "alt": "img"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_vm._v("此类个人信息仅用于注册，合同和联系目的，绝不会与第三方共享。"), _c('br'), _vm._v("有关我们的更多信息以及我们如何保护您的个人信息，请参阅我们的"), _c('a', {
    attrs: {
      "href": "/pdf/tips.pdf",
      "download": "隐私声明"
    }
  }, [_vm._v("隐私声明")]), _vm._v("。")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-6c58167c"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/components/case/Core.vue
// module id = 1353
// module chunks = 26